import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createProspectiveCustomer, IStepper_CreateAlert } from '@/types';

interface CreateAlertFormState {
  step: number;
  open: boolean;
  steps: IStepper_CreateAlert;
  formData: {} | (createProspectiveCustomer & { id: string });
}

const initialState: CreateAlertFormState = {
  step: 0,
  open: false,
  steps: {
    carDetails: {
      label: 'carDetails',
      subtitle: 'carDetailsSubtitle',
      step: 0,
    },
    personalInformation: {
      label: 'personalInformation',
      subtitle: 'personalInformationSubtitle',
      step: 1,
    },
  },
  formData: {},
};

const createAlertFormSlice = createSlice({
  name: 'createAlertForm',
  initialState,
  reducers: {
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
      state.open = false;
    },
    setOpen(state, action: PayloadAction<boolean>) {
      state.open = action.payload;
    },
    setFormData(state, action: PayloadAction<createProspectiveCustomer & { id: string }>) {
      state.formData = action.payload;
    },
    clearFormData(state) {
      state.formData = {};
    },
  },
});

export const { setStep, setOpen, setFormData, clearFormData } = createAlertFormSlice.actions;
export default createAlertFormSlice.reducer;
